<div class="fc-key-container" *ngFor="let kv of keyValues" [ngClass]="accentTheme">
    <h2>{{kv.label }}<fc-tool-tip [primary]="kv.additionalInfo" [secondary]="kv.description"></fc-tool-tip></h2>
    <div class="fc-key-value" [innerHtml]="formatKeyValue(kv)"></div>
    <div class="fc-key-icon" *ngIf="kv.icon"><i [ngClass]="kv.icon"></i></div>
</div>
